import { get, post, put } from 'lib/API';

export const loadProductBadges = async (
  [activeOnly]: any[],
  { token }: any
) => {
  return await get('v1/productBadges', token, activeOnly ? { active: true } : {});
};

export const createProductBadge = async (
  [name, colorHash]: any[],
  { token }: any
) => {
  return await post('v1/productBadges', token, { name, colorHash });
};

export const deactivateProductBadge = async (
  [badgeId]: any[],
  { token }: any
) => {
  return await put(`v1/productBadges/${badgeId}/deactivate`, token, {});
};